import { useEffect } from 'react'
import { Alert, Button, Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import {
    listNotifications,
    markNotificationRead,
    markNotificationsRead
} from '../actions/notificationActions'
import Loader from '../components/Loader'
import Pagination from '../components/Pagination'
import PushNotificationToggle from '../components/PushNotificationToggle'
import Template from '../components/Template'

const formatNotificationDate = value => new Intl.DateTimeFormat('ar-SA', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
}).format(new Date(value))

const getNotificationIcon = type => {
    if(type === 'news') return 'far fa-newspaper'
    if(type === 'document') return 'far fa-folder-open'
    if(type === 'event') return 'far fa-calendar-check'
    if(type === 'member') return 'fas fa-user-alt'
    if(type === 'admin') return 'fas fa-cog'
    return 'far fa-bell'
}

const Notifications = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()
    const { user } = useSelector(state => state.login)
    const { loading, error, notifications, count, page } = useSelector(state => state.notifications)

    const searchUrl = (key, value) => {
        const search = new URLSearchParams(location.search)
        if(search.has(key)) search.delete(key)
        search.append(key, value)
        return search.toString()
    }

    const notificationClickHandler = notification => {
        dispatch(markNotificationRead(notification._id))
        if(notification.link) history.push(notification.link)
    }

    const markAllHandler = () => {
        dispatch(markNotificationsRead())
        dispatch(listNotifications(location.search))
    }

    const isUnread = notification => user && !notification.readBy.some(id => id === user.data._id)

    useEffect(() => {
        dispatch(listNotifications(location.search))
    }, [dispatch, location])

    return (
        <Template>
            <h2 className='main__title'>مركز الإشعارات</h2>
            <Container>
                <div className='notifications__toolbar'>
                    <PushNotificationToggle />
                    <Button variant='info' onClick={markAllHandler}>
                        تحديد الكل كمقروء
                    </Button>
                </div>

                {loading ? <Loader />
                    : error ? <Alert variant='warning'>{error}</Alert>
                        : <div className='notifications'>
                            {notifications && notifications.length > 0
                                ? notifications.map(notification => (
                                    <button
                                        type='button'
                                        className={`notifications__item${isUnread(notification) ? ' notifications__item--unread' : ''}`}
                                        key={notification._id}
                                        onClick={() => notificationClickHandler(notification)}
                                    >
                                        <span className='notifications__icon'>
                                            <i className={getNotificationIcon(notification.type)}></i>
                                        </span>
                                        <span className='notifications__content'>
                                            <span className='notifications__head'>
                                                <strong>{notification.title}</strong>
                                                <time>{formatNotificationDate(notification.createdAt)}</time>
                                            </span>
                                            <span>{notification.message}</span>
                                        </span>
                                    </button>
                                ))
                                : <Alert variant='warning'>لا توجد إشعارات حالياً</Alert>}
                        </div>}

                {notifications && <Pagination
                    count={count}
                    page={page}
                    searchHandler={searchUrl}
                />}
            </Container>
        </Template>
    )
}

export default Notifications
